var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "dashboard-widget" }, [
    _c(
      "header",
      { staticClass: "dashboard-widget-header", attrs: { title: _vm.tooltip } },
      [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("h1", { staticClass: "has-text-ellipsis" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _vm.subtitle
              ? _c("small", [_vm._v(_vm._s(_vm.subtitle))])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.label
            ? _c("div", { staticClass: "column is-narrow" }, [
                _c("span", { staticClass: "tag", class: _vm.label_class }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
              ])
            : _vm._e(),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("section", { staticClass: "dashboard-widget-content" }, [
      _c("canvas"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }